import { render, staticRenderFns } from "./UserManagementModal.vue?vue&type=template&id=00bd5e05&scoped=true&"
import script from "./UserManagementModal.vue?vue&type=script&lang=js&"
export * from "./UserManagementModal.vue?vue&type=script&lang=js&"
import style0 from "./UserManagementModal.vue?vue&type=style&index=0&id=00bd5e05&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bd5e05",
  null
  
)

export default component.exports